async function httpClient(url, config) {
  const response = await fetch(url, config);

  const data = await getDataFromResponse(response);

  const finalResponse = {
      status: response.status,
      statusText: response.statusText,
      data,
  }

  if (!response.ok) throw finalResponse;

  return finalResponse;
};

const get = async (url, config) => {
  const getConfig = {
    ...config,
    method: 'GET',
  }

  return (
    await httpClient(url, getConfig)
  );
};

const post = async (url, config) => {
  const postConfig = {
    ...config,
    method: 'POST',
  }

  return (
    await httpClient(url, postConfig)
  );
};

const put = async (url, config) => {
  const putConfig = {
    ...config,
    method: 'PUT',
  }

  return (
    await httpClient(url, putConfig)
  );
};

const _delete = async (url, config) => {
  const getConfig = {
    ...config,
    method: 'DELETE',
  }

  return (
    await httpClient(url, getConfig)
  );
};

httpClient.get = get;
httpClient.post = post;
httpClient.put = put;
httpClient.delete = _delete;

const getDataFromResponse = async (response) => {
  try {
    return (await response.json());
  } catch(error) {
    try {
      return (await response.text())
    } catch {
      return null;
    }
  }
}

export default httpClient;
